export const viewEvents = {
  LANDING_PAGE_VIEWED: 'Ecom Landing Page Viewed',
  LANDING_PAGE_COUNTDOWN_VIEWED: 'Ecom Landing Page Countdown Viewed',
  LANDING_PAGE_ERROR_VIEWED: 'Ecom Landing Page Error Viewed',
  LANDING_PAGE_TIMEOUT_VIEWED: 'Ecom Landing Page Timeout Viewed',
  LANDING_PAGE_SUCCESS_VIEWED: 'Ecom Landing Page Success Viewed',
  LANDING_PAGE_CANCELLED_VIEWED: 'Ecom Landing Page Cancelled Viewed',
} as const;

export type ViewEventName = (typeof viewEvents)[keyof typeof viewEvents];

export const interactionEvents = {
  LANDING_PAGE_PHONENUMBER_SUBMITTED: 'Ecom Landing Page Phonenumber Submitted',
  LANDING_PAGE_UNIVERSAL_LINK_CLICKED: 'Ecom Landing Page Universal Link Clicked',
  LANDING_PAGE_UNIVERSAL_LINK_FAILED: 'Ecom Landing Page Universal Link Failed',
  LANDING_PAGE_GOOGLE_INTENT_LINK_CLICKED: 'Ecom Landing Page Google Intent Link Clicked',
  LANDING_PAGE_CUSTOM_SCHEME_LINK_CLICKED: 'Ecom Landing Page Custom Scheme Link Clicked',
  LANDING_PAGE_CUSTOM_SCHEME_LINK_AUTO_OPENED: 'Ecom Landing Page Custom Scheme Link Auto Opened',
  CROSS_DOMAIN_REMEMBER_ME_PREFILLED: 'Ecom Cross Domain Remember Me Prefilled',
  CROSS_DOMAIN_REMEMBER_ME_PERSISTED: 'Ecom Cross Domain Remember Me Persisted',
  STORAGE_ACCESS_GRANTED: 'Ecom Storage Access Granted',
  STORAGE_ACCESS_DENIED: 'Ecom Storage Access Denied',
} as const;

export type InteractionEventName = (typeof interactionEvents)[keyof typeof interactionEvents];

export const outcomeEvents = {
  LANDING_PAGE_REDIRECTED: 'Ecom Landing Page Redirected',
} as const;

export type OutcomeEventName = (typeof outcomeEvents)[keyof typeof outcomeEvents];

export const errorEvents = {
  ERROR_OCCURRED: 'Ecom Landing Page Error Occurred',
} as const;

export type ErrorEventName = (typeof errorEvents)[keyof typeof errorEvents];

export const errorReasons = {
  CLAIMS_INVALID: 'Claims Invalid',
  CLAIMS_FETCH_FAILED: 'Claims Fetch Failed',
  CLAIMS_MISSING: 'Claims Missing',
  MERCHANT_MISSING: 'Merchant Missing',
  MERCHANT_FETCH_FAILED: 'Merchant Fetch Failed',
  SUBMIT_FAILED: 'Submit Failed',
  STATUS_ERROR: 'Status Error',
  PAYMENT_FAILED: 'Payment Failed',
  UNKNOWN: 'Unknown',
} as const;

export type ErrorReason = (typeof errorReasons)[keyof typeof errorReasons];
